import { render } from "./CustomerDetailContentLoader.vue?vue&type=template&id=6e876cf0&scoped=true&ts=true"
import script from "./CustomerDetailContentLoader.vue?vue&type=script&lang=ts"
export * from "./CustomerDetailContentLoader.vue?vue&type=script&lang=ts"

import "./CustomerDetailContentLoader.vue?vue&type=style&index=0&id=6e876cf0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e876cf0"]])

export default __exports__